import { createApi } from '@reduxjs/toolkit/query/react'

import {
  BONUS_HISTORY_HEADER,
  GET_CLIENT,
  GET_HEADER_CLIENT,
  GET_NOTIFICATIONS_COUNT,
  GET_ORDER,
  GET_ORDERS,
  GET_TABLE_DATA,
  GET_UNVIEWED_ORDERS,
  GET_USER,
  GET_WIKI_FOLDER,
  GET_WIKI_SPACE,
} from 'shared/config/redux/constants/tags'

import fetchBaseQueryAxios from '../helpers/baseQueryWithReAuth'

export const globalAPI = createApi({
  reducerPath: 'GLOBAL_API',
  baseQuery: fetchBaseQueryAxios,
  tagTypes: [
    GET_ORDER,
    GET_ORDERS,
    GET_CLIENT,
    GET_HEADER_CLIENT,
    BONUS_HISTORY_HEADER,
    GET_USER,
    GET_TABLE_DATA,
    GET_UNVIEWED_ORDERS,
    GET_WIKI_FOLDER,
    GET_WIKI_SPACE,
    GET_NOTIFICATIONS_COUNT,
  ],
  endpoints: () => ({}),
})
